



import { Vue, Component } from 'vue-property-decorator';
import Form from './params-form.vue';
@Component({
  components: { Form }
})
export default class AddPage extends Vue {}
